var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#CC9A06"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0185 41.1818V111H64.3707V41.1818H77.0185ZM128.658 60.375C128.339 57.3977 126.999 55.0795 124.635 53.4205C122.294 51.7614 119.249 50.9318 115.499 50.9318C112.862 50.9318 110.601 51.3295 108.714 52.125C106.828 52.9205 105.385 54 104.385 55.3636C103.385 56.7273 102.874 58.2841 102.851 60.0341C102.851 61.4886 103.18 62.75 103.839 63.8182C104.521 64.8864 105.442 65.7955 106.601 66.5455C107.76 67.2727 109.044 67.8864 110.453 68.3864C111.862 68.8864 113.283 69.3068 114.714 69.6477L121.26 71.2841C123.896 71.8977 126.43 72.7273 128.862 73.7727C131.317 74.8182 133.51 76.1364 135.442 77.7273C137.396 79.3182 138.942 81.2386 140.078 83.4886C141.214 85.7386 141.783 88.375 141.783 91.3977C141.783 95.4886 140.737 99.0909 138.646 102.205C136.555 105.295 133.533 107.716 129.578 109.466C125.646 111.193 120.885 112.057 115.294 112.057C109.862 112.057 105.146 111.216 101.146 109.534C97.169 107.852 94.0554 105.398 91.8054 102.17C89.5781 98.9432 88.3736 95.0114 88.1918 90.375H100.635C100.817 92.8068 101.567 94.8295 102.885 96.4432C104.203 98.0568 105.919 99.2614 108.033 100.057C110.169 100.852 112.555 101.25 115.192 101.25C117.942 101.25 120.351 100.841 122.419 100.023C124.51 99.1818 126.146 98.0227 127.328 96.5455C128.51 95.0455 129.112 93.2955 129.135 91.2955C129.112 89.4773 128.578 87.9773 127.533 86.7955C126.487 85.5909 125.021 84.5909 123.135 83.7955C121.271 82.9773 119.089 82.25 116.589 81.6136L108.646 79.5682C102.896 78.0909 98.3509 75.8523 95.0099 72.8523C91.6918 69.8295 90.0327 65.8182 90.0327 60.8182C90.0327 56.7045 91.1463 53.1023 93.3736 50.0114C95.6236 46.9205 98.6804 44.5227 102.544 42.8182C106.408 41.0909 110.783 40.2273 115.669 40.2273C120.624 40.2273 124.964 41.0909 128.692 42.8182C132.442 44.5227 135.385 46.8977 137.521 49.9432C139.658 52.9659 140.76 56.4432 140.828 60.375H128.658ZM215.445 76.0909C215.445 83.6136 214.036 90.0568 211.217 95.4205C208.422 100.761 204.604 104.852 199.763 107.693C194.945 110.534 189.479 111.955 183.365 111.955C177.251 111.955 171.774 110.534 166.933 107.693C162.115 104.83 158.297 100.727 155.479 95.3864C152.683 90.0227 151.286 83.5909 151.286 76.0909C151.286 68.5682 152.683 62.1364 155.479 56.7955C158.297 51.4318 162.115 47.3295 166.933 44.4886C171.774 41.6477 177.251 40.2273 183.365 40.2273C189.479 40.2273 194.945 41.6477 199.763 44.4886C204.604 47.3295 208.422 51.4318 211.217 56.7955C214.036 62.1364 215.445 68.5682 215.445 76.0909ZM202.729 76.0909C202.729 70.7955 201.899 66.3295 200.24 62.6932C198.604 59.0341 196.331 56.2727 193.422 54.4091C190.513 52.5227 187.161 51.5795 183.365 51.5795C179.57 51.5795 176.217 52.5227 173.308 54.4091C170.399 56.2727 168.115 59.0341 166.456 62.6932C164.82 66.3295 164.001 70.7955 164.001 76.0909C164.001 81.3864 164.82 85.8636 166.456 89.5227C168.115 93.1591 170.399 95.9205 173.308 97.8068C176.217 99.6705 179.57 100.602 183.365 100.602C187.161 100.602 190.513 99.6705 193.422 97.8068C196.331 95.9205 198.604 93.1591 200.24 89.5227C201.899 85.8636 202.729 81.3864 202.729 76.0909Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237 444C306.036 444 362 388.036 362 319C362 249.964 306.036 194 237 194C167.964 194 112 249.964 112 319C112 388.036 167.964 444 237 444ZM237 351C254.673 351 269 336.673 269 319C269 301.327 254.673 287 237 287C219.327 287 205 301.327 205 319C205 336.673 219.327 351 237 351Z",
    fill: "#FFCD39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205 319C205 310.778 208.101 303.28 213.197 297.612L146.15 233.144C124.98 255.537 112 285.753 112 319C112 388.036 167.964 444 237 444C241.041 444 245.037 443.808 248.98 443.433L240.067 350.855C239.057 350.951 238.034 351 237 351C219.327 351 205 336.673 205 319ZM260.067 341.18L327.104 405.639C348.714 383.17 362 352.636 362 319C362 249.964 306.036 194 237 194C232.91 194 228.866 194.196 224.877 194.58L233.79 287.159C234.846 287.054 235.917 287 237 287C254.673 287 269 301.327 269 319C269 327.611 265.599 335.427 260.067 341.18Z",
    fill: "#CC9A06"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 319,
    r: 32,
    fill: "#FAFAFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_835",
    x: 52.3711,
    y: 40.2266,
    width: 167.074,
    height: 87.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_835",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIso);
export default __webpack_public_path__ + "static/media/iso.63e864a5c4620778a22b447635f1b231.svg";
export { ForwardRef as ReactComponent };